const toNumber = (v: any) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
    const normalized = String(v).replace(',', '.');
    const parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
};

// ---------- ROUND ----------
const round = (value: any) => {
    const num = toNumber(value);
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

// ---------- IS CUSTOMER HT ----------
export const isCustomerHT = (customer: any): boolean =>
    customer?.isHT === true ||
    customer?.isHT === 'true' ||
    customer?.isHT === 1 ||
    customer?.isHT === '1' ||
    customer?.isHt === true ||
    customer?.isHt === 'true';

// ---------- LINE TOTAL HT ----------
export const getInvoiceLineTotalHT = (items: any[]) => {
    const totalHT = items.reduce((acc: number, item: any) => {
        const price = toNumber(item.price);
        const quantity = toNumber(item.quantity);
        const discountValue = toNumber(item.discountValue);

        let discount = 0;
        if (item.discountType === "percent")
            discount = price * quantity * (discountValue / 100);
        else if (item.discountType === "value")
            discount = discountValue;

        const lineTotal = price * quantity - discount;
        return acc + lineTotal;
    }, 0);

    return round(totalHT);
};

// ---------- TOTAL HT ----------
export const getTotalHT = (items: any) => {
    let totalHT = 0;
    for (const item of items) {
        totalHT += getInvoiceLineTotalHT([item]);
    }
    return round(totalHT);
};

// ---------- TOTAL TTC ----------
export const getTotalTTC = (
    items: any[],
    options?: {
        isCustomerHT?: boolean;
    },
) => {
    const totalHT = getTotalHT(items);
    if (options?.isCustomerHT) return totalHT;

    const totalVAT = items.reduce((acc: number, item: any) => {
        const lineHT = getInvoiceLineTotalHT([item]);
        const vatRate = toNumber(item.vat);
        const lineVAT = round(lineHT * (vatRate / 100));
        return acc + lineVAT;
    }, 0);

    return round(totalHT + totalVAT);
};

// ---------- TOTAL MARGIN ----------
export const getTotalMargin = (items: any) => {
    let totalPurchasePrice = items.reduce(
        (acc: number, item: any) =>
            acc + (toNumber(item.totalPurchasePrice) * toNumber(item.quantity) || 0),
        0
    );

    let totalSellPrice = getTotalHT(items);

    const itemWithoutTotalPurchasePrice = items.find(
        (item: any) =>
            (item.totalPurchasePrice === undefined ||
                item.totalPurchasePrice === null) &&
            !item._id?.includes("custom")
    );

    if (itemWithoutTotalPurchasePrice) return 0;
    if (!totalPurchasePrice) return 0;

    return totalSellPrice - totalPurchasePrice;
};

export { round };
